import { css } from '@emotion/css';
import { Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles';
import { Queries } from '@/queries/Queries';

import { Button } from '../../atoms/Button';
import { InformationPaper } from '../../atoms/InformationPaper';

type NurseNoticeBannerProps = {
  patientId: string;
};

export const NurseNoticeBanner = ({ patientId }: NurseNoticeBannerProps) => {
  const { t } = useTranslation();
  const migitateMutation = Queries.observations.useMitigateNotice();
  const styles = useStyles(makeStyles);
  const noticeQuery = Queries.practitioner.useNurseNotice(patientId);

  const notice = noticeQuery.data;
  if (!notice) {
    return null;
  }

  return (
    <InformationPaper className={styles.container} isSquare variant="outlined">
      <Typography variant="subtitle">
        {t('patientNavigation.notice.banner')}
      </Typography>
      <Button
        id="mitigate-notice-button"
        pending={migitateMutation.isPending || noticeQuery.isPending}
        variant="contained"
        onClick={() =>
          migitateMutation.mutate({
            patient_id: notice.patient_id,
            id: notice.id,
          })
        }
      >
        {t('patientNavigation.notice.mitigateNotify')}
      </Button>
    </InformationPaper>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing(8, 12)};
  `,
});
